module.exports = __webpack_public_path__ + "static/media/platform_5.59e56faa.svg";